import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useState } from "react";

function PageHeader() {
  return (
    <section className="relative min-h-[50vh] flex items-center justify-center overflow-hidden rounded-3xl mx-4 lg:mx-8 mt-4">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20background%20with%20golden%20network%20nodes%20and%20connections%20forming%20a%20mesh%20pattern%2C%20deep%20charcoal%20black%20base%20with%20warm%20gold%20glowing%20nodes%2C%20fintech%20data%20network%20visualization%2C%20minimalist%20and%20elegant%20corporate%20style&width=1600&height=700&seq=contact-header-001&orientation=landscape"
          alt="連絡先背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
      </div>
      <div className="relative z-10 text-center px-4">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary-500/40 bg-primary-500/10 backdrop-blur-sm mb-4">
          <span className="text-primary-500 text-xs font-medium tracking-wide">お問い合わせ</span>
        </div>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4">お問い合わせ</h1>
        <p className="text-background-300 text-base max-w-xl mx-auto">
          ご質問やご相談がございましたら、お気軽にご連絡ください
        </p>
      </div>
    </section>
  );
}

function ContactInfoSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className={`py-16 md:py-24 px-4 lg:px-8 animate-on-scroll ${isVisible ? "is-visible" : ""}`}>
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Left */}
        <div>
          <div className="inline-flex items-center px-3 py-1.5 rounded-md bg-primary-100 mb-6">
            <span className="text-primary-700 text-xs font-bold uppercase tracking-wider">連絡先</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
            いつでも
            <br />
            お話を
            <br />
            伺います
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed mb-6">
            ご質問、ご相談、またはサービスに関するお問い合わせは、以下の連絡先からお願いいたします。
            専門の担当者が迅速に対応させていただきます。
          </p>

          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-500" />
              </div>
              <div>
                <p className="text-foreground-500 text-xs">メール</p>
                <a href="mailto:admin@bankcheckdata-card.jp" className="text-foreground-950 font-medium text-sm hover:text-primary-500 transition-colors">
                  admin@bankcheckdata-card.jp
                </a>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-phone-line text-primary-500" />
              </div>
              <div>
                <p className="text-foreground-500 text-xs">電話</p>
                <p className="text-foreground-950 font-medium text-sm">03-1234-5678</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-map-pin-line text-primary-500" />
              </div>
              <div>
                <p className="text-foreground-500 text-xs">住所</p>
                <p className="text-foreground-950 font-medium text-sm">東京都千代田区丸の内1-1-1 金融タワー28F</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-time-line text-primary-500" />
              </div>
              <div>
                <p className="text-foreground-500 text-xs">営業時間</p>
                <p className="text-foreground-950 font-medium text-sm">月曜日〜金曜日 9:00 - 18:00</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Card */}
        <div className="bg-background-100 rounded-2xl p-8 lg:p-10">
          <div className="mb-6">
            <p className="text-foreground-950 text-lg font-medium mb-2">
              専門サポートチームに連絡
            </p>
            <p className="text-foreground-500 text-sm">
              営業時間内であれば、平均15分以内にご返信いたします。
            </p>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20businesswoman%20portrait%20smiling%20warmly%2C%20corporate%20headshot%20style%2C%20neutral%20background%2C%20friendly%20and%20approachable%20expression%2C%20soft%20studio%20lighting&width=100&height=100&seq=support-avatar-001&orientation=squarish"
                alt="カスタマーサポート"
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <p className="text-foreground-950 font-medium text-sm">山田 梨花</p>
                <p className="text-foreground-500 text-xs">カスタマーサクセスマネージャー</p>
              </div>
            </div>
            <a
              href="mailto:admin@bankcheckdata-card.jp"
              className="w-10 h-10 rounded-lg bg-background-200/70 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-all"
            >
              <i className="ri-arrow-right-line text-foreground-600" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function ContactFormSection() {
  const { ref, isVisible } = useScrollAnimation();
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormState({ name: "", email: "", company: "", message: "" });
    }, 3000);
  };

  return (
    <section ref={ref} className={`py-16 md:py-24 px-4 lg:px-8 bg-background-100 animate-on-scroll ${isVisible ? "is-visible" : ""}`}>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">メッセージを送信</h2>
          <p className="text-foreground-500 text-sm">
            下記フォームにご記入いただき、送信ボタンをクリックしてください
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10">
          {submitted ? (
            <div className="text-center py-10">
              <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-check-line text-primary-500 text-2xl" />
              </div>
              <h3 className="text-foreground-950 font-bold text-lg mb-2">送信完了</h3>
              <p className="text-foreground-500 text-sm">お問い合わせありがとうございます。担当者よりご連絡いたします。</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-foreground-700 text-sm font-medium mb-2">お名前</label>
                  <input
                    type="text"
                    name="name"
                    value={formState.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-foreground-950 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 transition-all"
                    placeholder="山田 太郎"
                  />
                </div>
                <div>
                  <label className="block text-foreground-700 text-sm font-medium mb-2">メールアドレス</label>
                  <input
                    type="email"
                    name="email"
                    value={formState.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-foreground-950 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 transition-all"
                    placeholder="example@company.jp"
                  />
                </div>
              </div>
              <div>
                <label className="block text-foreground-700 text-sm font-medium mb-2">会社名</label>
                <input
                  type="text"
                  name="company"
                  value={formState.company}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-foreground-950 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 transition-all"
                  placeholder="株式会社○○"
                />
              </div>
              <div>
                <label className="block text-foreground-700 text-sm font-medium mb-2">お問い合わせ内容</label>
                <textarea
                  name="message"
                  value={formState.message}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-foreground-950 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 transition-all resize-none"
                  placeholder="お問い合わせ内容をご記入ください（500文字以内）"
                />
                <p className="text-foreground-400 text-xs mt-1 text-right">{formState.message.length}/500</p>
              </div>
              <button
                type="submit"
                className="w-full md:w-auto px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors flex items-center justify-center gap-2"
              >
                <span>送信する</span>
                <i className="ri-send-plane-line" />
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}

function MapSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className={`py-16 md:py-24 px-4 lg:px-8 animate-on-scroll ${isVisible ? "is-visible" : ""}`}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">アクセス</h2>
          <p className="text-foreground-500 text-sm">東京駅から徒歩5分</p>
        </div>
        <div className="rounded-2xl overflow-hidden h-[400px] md:h-[500px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.8280303803786!2d139.7649303!3d35.6812362!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188c0d02d8064d%3A0xd11d5d7c6d5f5c6!2z5p2x5Lqs6aeF!5e0!3m2!1sja!2sjp!4v1600000000000!5m2!1sja!2sjp"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="BankCheckData Office Location"
          />
        </div>
      </div>
    </section>
  );
}

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <PageHeader />
      <ContactInfoSection />
      <ContactFormSection />
      <MapSection />
    </div>
  );
}